// @ts-strict-ignore
import closeIcon from '@/assets/svg/closeIcon.svg'
import Image from 'next/image'
import React, { FC } from 'react'

import cls from '@/screens/Cart/page/ui/applied-service-item/applied-service-item.module.scss'

import { TCartItem, useCart } from '@/entities/cart'

import { truncateString } from '@/shared/lib/utils/common/truncateString'
import { formatPrice } from '@/shared/lib/utils/price/format-price'
import { Button } from '@/shared/ui'
import { Icon } from '@/shared/ui/icon'

import { DeleteItemClick } from '../TotalProductSetItem'

import cl from './total-product-item.module.scss'

type TotalProductItemProps = {
	onClick?: DeleteItemClick
} & TCartItem

/**
 * Component for displaying goods in the list of active services and accessories
 *
 * @param props
 *
 * */
export const TotalProductItem: FC<TotalProductItemProps> = props => {
	const { RELATED_PRODUCTS, ID_BASKET, ID, PRICE, TITLE, onClick, TYPE_PRODUCTS } = props
	const { getBasketItem } = useCart()
	const isRelatedProductInCart = !!getBasketItem(RELATED_PRODUCTS)
	const isAcsProduct = TYPE_PRODUCTS === `accessory`

	const image = TITLE.includes(`iPort`)
		? `https://storage.yandexcloud.net/tf-bitrix-upload/iport/services/card.jpg`
		: `https://storage.yandexcloud.net/tf-bitrix-upload/iport/services/police.jpg`

	return (
		<li className={cl.totalProductItem}>
			<Image
				src={image}
				width={40}
				height={40}
				quality={100}
				loading="lazy"
				aria-hidden
				alt="иконка услуги"
				className={cls.image}
			/>
			<div className={cl.totalProductItem__textWrap}>
				<span className={cl.totalProductItem__price}>{formatPrice(PRICE.VALUE)}</span>
				<h4>{truncateString(TITLE)}</h4>
			</div>

			<Button
				aria-label="Удалить товар из корзины"
				theme="link"
				size="S"
				onClick={() => onClick(ID_BASKET, ID, isRelatedProductInCart, isAcsProduct)}>
				<Icon icon={closeIcon} width={9} height={9} aria-hidden="true" />
			</Button>
		</li>
	)
}
